import { kycDocumentsService } from '@/services/kycDocumentsService';
import { KycDocumentsTokenValidationResponse } from '@/types/kycDocuments.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

/**
 * Hook for KYC documents token validation
 * Validates if a KYC documents token is valid and returns available document groups
 *
 * @param token - The KYC documents token to validate
 * @param options - Query options
 * @returns Query result with token validation data and document groups
 */
export const useKycDocumentsTokenValidation = (
  token: string,
  options?: { enabled?: boolean }
): UseQueryResult<KycDocumentsTokenValidationResponse, Error> => {
  return useQuery({
    queryKey: ['validateKycDocumentsToken', token],
    queryFn: () => kycDocumentsService.validateKycDocumentsToken(token),
    retry: false, // Don't retry token validation
    staleTime: 0, // Always check token freshness
    gcTime: 0, // Don't cache token validation results
    enabled: options?.enabled !== false && !!token, // Only enabled if token exists
  });
};
